define(["require", "exports", "jquery", "knockout", "log", "../utils/tools", "../models/UserContext"], function (require, exports, $, ko, log, tools, UserContext) {
    "use strict";
    var ExporDataWithDetails = /** @class */ (function () {
        function ExporDataWithDetails() {
            this.totalExported = ko.observable(0);
            this.detailExportPromises = [];
        }
        ExporDataWithDetails.prototype.openExportToExcel = function (title, entityName, masterDatasource, detailsDataSources) {
            var self = this;
            self.title = title;
            self.entityName = entityName;
            self.masterDatasource = masterDatasource;
            self.detailsDataSources = detailsDataSources;
            self.initExportWindow();
        };
        ExporDataWithDetails.prototype.placeholder = function () {
            return $("<li class='list-item' id='placeholder'>Drop Here!</li>");
        };
        ExporDataWithDetails.prototype.initExportWindow = function () {
            var self = this;
            self.modal = tools.editModal({
                title: "Export Data Wizard - ".concat(self.title),
                buttonTitle: "Export",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.doExport(event.currentTarget, modal);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'export-detailed-data-template', data: $root }\"></div>");
                    ko.applyBindings(self, modal);
                    self.initColumnSelector(self.masterDatasource);
                    ko.utils.arrayForEach(self.detailsDataSources, function (detailsDataSource) {
                        self.initColumnSelector(detailsDataSource);
                    });
                }
            });
        };
        ExporDataWithDetails.prototype.initColumnSelector = function (dataSource) {
            var self = this;
            var container = document.getElementById(dataSource.id);
            $(".sortable-listA", container).kendoSortable({
                connectWith: "#".concat(dataSource.id, " .sortable-listB"),
                placeholder: self.placeholder,
                cursor: "move",
                change: function (e) {
                    $(e.item).removeClass("selected");
                }
            });
            $(".sortable-listB", container).kendoSortable({
                connectWith: "#".concat(dataSource.id, " .sortable-listA"),
                placeholder: self.placeholder,
                cursor: "move",
                change: function (e) {
                    var column = ko.utils.arrayFirst(dataSource.allColumns(), function (item) {
                        return item.field() === $(e.item).data("id");
                    });
                    $(e.item).removeClass("selected");
                    if (e.action === "receive") {
                        if (column) {
                            dataSource.selectedColumns.splice(e.newIndex, 0, column);
                        }
                    }
                    if (e.action === "remove") {
                        if (column) {
                            dataSource.selectedColumns.remove(function (item) { return item.field() === column.field(); });
                        }
                    }
                    if (e.action === "sort") {
                        if (column) {
                            dataSource.selectedColumns.splice(e.newIndex, 0, dataSource.selectedColumns.splice(e.oldIndex, 1)[0]);
                        }
                    }
                }
            });
            ko.utils.arrayForEach(dataSource.allColumns(), function (item) {
                if (!item.hidden() && item.field()) {
                    $(".sortable-listA [data-id=\"".concat(item.field(), "\"]"), container).removeClass("selected").appendTo($(".sortable-listB", container));
                }
            });
            $(container).on("click", "li", function (event) {
                $(event.currentTarget).toggleClass("selected");
            });
        };
        ExporDataWithDetails.prototype.addColumns = function (dataSource, event) {
            var container = document.getElementById(dataSource.id);
            $(".sortable-listA .list-item.selected", container).each(function (index, elm) {
                var column = ko.utils.arrayFirst(dataSource.allColumns(), function (item) {
                    return item.field() === $(elm).data("id");
                });
                if (column) {
                    dataSource.selectedColumns.push(column);
                }
            });
            $(".sortable-listA .list-item.selected", container).removeClass("selected").appendTo($(".sortable-listB", container));
        };
        ExporDataWithDetails.prototype.removeColumns = function (dataSource, event) {
            var container = document.getElementById(dataSource.id);
            $(".sortable-listB .list-item.selected", container).each(function (index, elm) {
                dataSource.selectedColumns.remove(function (item) { return item.field() === $(elm).data("id"); });
            });
            $(".sortable-listB .list-item.selected", container).removeClass("selected").appendTo($(".sortable-listA", container));
        };
        ExporDataWithDetails.prototype.showColumns = function (dataSource, event) {
            dataSource.showColumns(!dataSource.showColumns());
        };
        ExporDataWithDetails.prototype.doExport = function (btn, modal) {
            var self = this;
            var deferred = $.Deferred();
            var columns = $.map(self.masterDatasource.selectedColumns(), function (item) {
                return { field: item.field() };
            });
            self.detailExportPromises = [];
            self.detailExportPromises.push(deferred);
            var exporter = new kendo.ExcelExporter({
                columns: columns,
                allPages: true,
                dataSource: self.masterDatasource.dataSource
            });
            exporter.workbook().then(function (book, data) {
                deferred.resolve({
                    listType: "vertical",
                    data: data,
                    sheet: book.sheets[0],
                    dataSource: self.masterDatasource
                });
            });
            ko.utils.arrayForEach(self.detailsDataSources, function (detailsDataSource) {
                if (detailsDataSource.selected()) {
                    var detailsDeferred = $.Deferred();
                    self.detailExportPromises.push(detailsDeferred);
                    var detailsColumns = $.map(detailsDataSource.selectedColumns(), function (item) {
                        return { field: item.field() };
                    });
                    var detailsExporter = new kendo.ExcelExporter({
                        columns: detailsColumns,
                        allPages: true,
                        dataSource: detailsDataSource.dataSource
                    });
                    detailsExporter.workbook().then(function (book, data) {
                        detailsDeferred.resolve({
                            listType: "table",
                            data: data,
                            sheet: book.sheets[0],
                            dataSource: detailsDataSource
                        });
                    });
                }
            });
            $.when.apply(null, self.detailExportPromises)
                .then(function () {
                // get the export results
                var detailExports = $.makeArray(arguments);
                self.createExportFile(detailExports);
                $(btn).button("reset");
            });
        };
        ExporDataWithDetails.prototype.createExportFile = function (detailsData) {
            var self = this;
            var sheets = [];
            ko.utils.arrayForEach(detailsData, function (item) {
                if (item.listType === "vertical") {
                    sheets.push(self.prefillKeyValueSheet(item));
                }
                else {
                    sheets.push(self.prefillTableSheet(item));
                }
            });
            var workbook = new kendo.ooxml.Workbook({
                sheets: sheets
            });
            var fileName = kendo.toString(new Date(), "yyyy-MM-dd-HH-mm-ss"); // "2015-04-21-16-45-59-igoldstein@telego.net-PhoneNumbers.xlsx"
            fileName += "-".concat(UserContext.currentUser().userName, "-").concat(self.title.replace(" ", ""), ".xlsx");
            //save the file as Excel file with extension xlsx
            kendo.saveAs({
                dataURI: workbook.toDataURL(),
                fileName: fileName,
                proxyURL: "/Export/SaveProxy",
                forceProxy: true
            });
            self.logExport(fileName, workbook.toDataURL(), false);
        };
        ExporDataWithDetails.prototype.prefillKeyValueSheet = function (data) {
            var columnsArray = ko.utils.arrayMap(data.dataSource.selectedColumns(), function (item) {
                return {
                    field: item.field(),
                    template: item.template(),
                    useTemplateValue: item.useTemplateValue(),
                    autoWidth: true
                };
            });
            var columns = {};
            ko.utils.arrayForEach(columnsArray, function (item) {
                columns[item.field] = item;
            });
            var headerCell = ko.utils.arrayMap(data.dataSource.selectedColumns(), function (item) {
                return {
                    value: item.field(),
                    background: "#DDD9C4"
                };
            });
            var rows = [];
            ko.utils.arrayForEach(data.data, function (item) {
                ko.utils.arrayForEach(headerCell, function (field) {
                    var cells = [];
                    var column = columns[field.value];
                    var valueCell = item[field.value];
                    cells.push({ value: column.field, background: "#DDD9C4" });
                    if (column.useTemplateValue) {
                        var template = kendo.template(column.template);
                        valueCell = template(item);
                        valueCell = tools.stripHtml(valueCell);
                        cells.push({ value: valueCell });
                    }
                    else {
                        cells.push({ value: valueCell });
                    }
                    rows.push({
                        cells: cells
                    });
                });
            });
            return {
                columns: columnsArray,
                // Title of the sheet
                title: data.dataSource.title,
                // Rows of the sheet
                rows: rows
            };
        };
        ExporDataWithDetails.prototype.prefillTableSheet = function (data) {
            var columnsArray = ko.utils.arrayMap(data.dataSource.selectedColumns(), function (item) {
                return {
                    field: item.field(),
                    template: item.template(),
                    useTemplateValue: item.useTemplateValue(),
                    autoWidth: true
                };
            });
            var columns = {};
            ko.utils.arrayForEach(columnsArray, function (item) {
                columns[item.field] = item;
            });
            var headerCell = ko.utils.arrayMap(data.dataSource.selectedColumns(), function (item) {
                return {
                    value: item.field(),
                    background: "#DDD9C4"
                };
            });
            var rows = [{
                    cells: headerCell
                }];
            ko.utils.arrayForEach(data.data, function (item) {
                var cells = [];
                ko.utils.arrayForEach(headerCell, function (field) {
                    var column = columns[field.value];
                    var valueCell = item[field.value];
                    if (column.useTemplateValue) {
                        var template = kendo.template(column.template);
                        valueCell = template(item);
                        valueCell = tools.stripHtml(valueCell);
                        cells.push({ value: valueCell });
                    }
                    else {
                        cells.push({ value: valueCell });
                    }
                });
                rows.push({
                    cells: cells
                });
            });
            return {
                columns: columnsArray,
                // Title of the sheet
                title: data.dataSource.title,
                // Rows of the sheet
                rows: rows
            };
        };
        ExporDataWithDetails.prototype.logExport = function (fileName, fileData, logData) {
            var self = this;
            var transportData = self.masterDatasource.dataSource.options.transport.read;
            var requestData = {
                filter: self.masterDatasource.dataSource.options.filter,
                query: transportData.data ? transportData.data() : ""
            };
            var logResult = {
                exportedSelected: true,
                fileName: fileName,
                exportRequestUrl: transportData.url,
                exportRequestData: requestData,
                totalRecords: self.totalExported()
            };
            var logString = JSON.stringify(logResult);
            tools.ajaxPost({
                url: "/logs/logexport",
                data: {
                    entityName: self.entityName,
                    logJson: logString,
                    fileName: fileName,
                    fileData: logData ? fileData : "data too long"
                }
            }).done(function () {
                log.log("export log saved");
            });
        };
        return ExporDataWithDetails;
    }());
    return ExporDataWithDetails;
});
//# sourceMappingURL=exportDataWithDetails.js.map


//////////////////
// WEBPACK FOOTER
// ./build/shared/exportDataWithDetails.js
// module id = 155
// module chunks = 2